<template>
  <div class="wechat-login">
    <button @click="handleWechatLogin" class="wechat-btn">
      <span class="wechat-icon">💚</span>
      <span>微信一键登录</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WechatLogin',
  
  methods: {
    handleWechatLogin() {
      this.$store.dispatch('showToast', '正在跳转微信登录...')
      
      // 模拟微信登录
      setTimeout(() => {
        this.$emit('login-success', {
          id: `wx_${Date.now()}`,
          name: '微信用户',
          avatar: '👤',
          loginType: 'wechat'
        })
      }, 1500)
    }
  }
}
</script>

<style scoped>
.wechat-btn {
  width: 100%;
  padding: 18px;
  background: #07C160;
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s;
  box-shadow: 0 8px 32px rgba(7, 193, 96, 0.3);
}

.wechat-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(7, 193, 96, 0.4);
  background: #06AD56;
}

.wechat-icon {
  font-size: 24px;
}
</style>